import { HttpInterceptorFn } from '@angular/common/http';
import { CONTEXT_TOKEN_SESSION_TOKEN } from '@effy-tech/angular-common/web-service';
import { BehaviorSubject, mergeMap, take } from 'rxjs';

export const sessionToken = new BehaviorSubject<string>('');

export const simplifiedSessionTokenInterceptor: HttpInterceptorFn = (request, next) => {
  // Determine if the current request is allowed to inject SessionToken
  const requestHasSessionToken = request.context.get(CONTEXT_TOKEN_SESSION_TOKEN);
  // Then handle requests with Tokens
  if (requestHasSessionToken) {
    return sessionToken.pipe(
      take(1),
      mergeMap(token =>
        next(
          request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          })
        )
      )
    );
  }
  return next(request);
};
